module.exports = __webpack_public_path__ + "img/fees_icn.5237970a.png";